import { Box, styled, TextV2 } from '@withjoy/joykit';

export const StyledTitle = styled(TextV2)`
  margin-left: 0.24rem;
  margin-right: 0.24rem;
  word-break: break-word;
`;

// Always in the DOM so SSR includes the photo slot. Hidden on desktop by CSS (the AuxFrame
// sidebar shows the photo there instead). Replaces the JS-based `isSmallScreen &&` gate that
// excluded the photo from SSR — useMediaQuery defaults to false on the server, so the CoverPhoto
// was absent from the initial HTML and mobile hydration popped it in, causing CLS ≈ 0.12.
export const MobileOnlyCoverPhotoBox = styled(Box)`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm4}) {
    display: none;
  }
`;
